import { PawPrint, MapPin, UserPlus, RefreshCw, Sparkles } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

/**
 * Story Owner Panel 2: "Nowość" - 3 kroki dla wolontariusza/pracownika schroniska
 */
export const InstagramStoryOwnerPanel2 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", zIndex: 0 }}
      />
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: "8px", background: "linear-gradient(90deg, #4E8A6E 0%, #6BAF8D 50%, #4E8A6E 100%)", zIndex: 2 }} />

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "150px 72px 80px",
          position: "relative",
          zIndex: 1,
        }}
      >
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "12px",
            background: "#2D5A3D",
            padding: "12px 26px",
            borderRadius: "999px",
            marginBottom: "24px",
          }}
        >
          <Sparkles style={{ width: "24px", height: "24px", color: "#FFFFFF" }} />
          <span style={{ fontSize: "24px", fontWeight: 800, color: "#FFFFFF", letterSpacing: "0.08em", textTransform: "uppercase" }}>
            Nowość dla schronisk
          </span>
        </div>

        <h1 style={{ fontSize: "78px", fontWeight: 900, color: "#2D5A3D", margin: "0 0 16px", textAlign: "center", lineHeight: 1.05 }}>
          Wolontariuszu,<br />pracowniku - to dla Ciebie
        </h1>
        <p style={{ fontSize: "32px", fontWeight: 600, color: "#5A8A70", margin: "0 0 44px", textAlign: "center", lineHeight: 1.3, maxWidth: "900px" }}>
          Załóż konto i aktualizuj potrzeby schroniska. Łatwe i bezpłatne 🐾
        </p>

        {/* Steps */}
        <div style={{ display: "flex", flexDirection: "column", gap: "22px", width: "100%", maxWidth: "920px" }}>
          {/* Step 1 */}
          <div style={{ background: "rgba(255,255,255,0.96)", borderRadius: "28px", padding: "30px 38px", boxShadow: "0 6px 20px rgba(0,0,0,0.08)", display: "flex", alignItems: "flex-start", gap: "26px" }}>
            <div style={{ background: "#2D5A3D", borderRadius: "20px", width: "76px", height: "76px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: "40px", fontWeight: 900, color: "#FFFFFF" }}>
              1
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                <MapPin style={{ width: "30px", height: "30px", color: "#2D5A3D" }} />
                <p style={{ fontSize: "32px", fontWeight: 800, color: "#2D5A3D", margin: 0, lineHeight: 1.2 }}>
                  Znajdź schronisko na mapie
                </p>
              </div>
              <p style={{ fontSize: "26px", fontWeight: 600, color: "#5A8A70", margin: 0, lineHeight: 1.4 }}>
                Większość już tam jest - sprawdź swoje
              </p>
            </div>
          </div>

          {/* Step 2 */}
          <div style={{ background: "rgba(255,255,255,0.96)", borderRadius: "28px", padding: "30px 38px", boxShadow: "0 6px 20px rgba(0,0,0,0.08)", display: "flex", alignItems: "flex-start", gap: "26px" }}>
            <div style={{ background: "#2D5A3D", borderRadius: "20px", width: "76px", height: "76px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: "40px", fontWeight: 900, color: "#FFFFFF" }}>
              2
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                <UserPlus style={{ width: "30px", height: "30px", color: "#2D5A3D" }} />
                <p style={{ fontSize: "32px", fontWeight: 800, color: "#2D5A3D", margin: 0, lineHeight: 1.2 }}>
                  Załóż konto w 2 minuty
                </p>
              </div>
              <p style={{ fontSize: "26px", fontWeight: 600, color: "#5A8A70", margin: 0, lineHeight: 1.4 }}>
                Mailem albo przez Google - bez papierów
              </p>
            </div>
          </div>

          {/* Step 3 highlighted */}
          <div style={{ background: "#2D5A3D", borderRadius: "28px", padding: "30px 38px", boxShadow: "0 10px 32px rgba(45,90,61,0.32)", display: "flex", alignItems: "flex-start", gap: "26px" }}>
            <div style={{ background: "rgba(255,255,255,0.2)", borderRadius: "20px", width: "76px", height: "76px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: "40px", fontWeight: 900, color: "#FFFFFF" }}>
              3
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                <RefreshCw style={{ width: "30px", height: "30px", color: "#FFFFFF" }} />
                <p style={{ fontSize: "32px", fontWeight: 800, color: "#FFFFFF", margin: 0, lineHeight: 1.2 }}>
                  Aktualizuj potrzeby
                </p>
              </div>
              <p style={{ fontSize: "26px", fontWeight: 700, color: "#D1FAE5", margin: 0, lineHeight: 1.4 }}>
                Karma, koce, leki - kiedy się zmienią
              </p>
            </div>
          </div>
        </div>

        <p style={{ fontSize: "28px", fontWeight: 800, color: "#2D5A3D", margin: "40px 0 0", textAlign: "center" }}>
          Bezpłatnie, na zawsze 💚
        </p>
      </div>

      <div style={{ padding: "0 80px 100px", display: "flex", justifyContent: "center", position: "relative", zIndex: 1 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <div style={{ background: "#4E8A6E", borderRadius: "14px", width: "52px", height: "52px", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <PawPrint style={{ width: "28px", height: "28px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "28px", fontWeight: 700, color: "#2D5A3D" }}>gdzieschronisko.pl</span>
        </div>
      </div>
    </div>
  );
};
